 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML01_COVER from '@/components/xhtml/01_Cover'
 import XHTML02_TITLEPAGE from '@/components/xhtml/02_Titlepage'
 import XHTML03_COPYRIGHT from '@/components/xhtml/03_Copyright'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ABBREVIATIONS from '@/components/xhtml/05_Abbreviations'
 import XHTML06_PREFACE from '@/components/xhtml/06_Preface'
 import XHTML07_INTRODUCTION from '@/components/xhtml/07_Introduction'
 import XHTML08_BRADFORD from '@/components/xhtml/08_Bradford'
 import XHTML09_GATESHEAD from '@/components/xhtml/09_Gateshead'
 import XHTML10_HULL from '@/components/xhtml/10_Hull'
 import XHTML11_LEEDS from '@/components/xhtml/11_Leeds'
 import XHTML12_NEWCASTLE from '@/components/xhtml/12_Newcastle'
 import XHTML13_ROTHERHAM from '@/components/xhtml/13_Rotherham'
 import XHTML14_SHEFFIELD from '@/components/xhtml/14_Sheffield'
 import XHTML15_SOUTH_SHIELDS from '@/components/xhtml/15_South_Shields'
 import XHTML16_SOUTH_YORKSHIRE_SUPERTRAM from '@/components/xhtml/16_South_Yorkshire_Supertram'
 import XHTML17_SUNDERLAND from '@/components/xhtml/17_Sunderland'
 import XHTML18_TYNE_WEAR_METRO from '@/components/xhtml/18_Tyne_Wear_Metro'
 import XHTML19_PRESERVATION from '@/components/xhtml/19_Preservation'
 import XHTML20_BIBLIOGRAPHY from '@/components/xhtml/20_Bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/01_Cover",
 			"name" : "xhtml/01_Cover",
 			"component" : XHTML01_COVER
 		},
 		{
 			"path" : "/xhtml/02_Titlepage",
 			"name" : "xhtml/02_Titlepage",
 			"component" : XHTML02_TITLEPAGE
 		},
 		{
 			"path" : "/xhtml/03_Copyright",
 			"name" : "xhtml/03_Copyright",
 			"component" : XHTML03_COPYRIGHT
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Abbreviations",
 			"name" : "xhtml/05_Abbreviations",
 			"component" : XHTML05_ABBREVIATIONS
 		},
 		{
 			"path" : "/xhtml/06_Preface",
 			"name" : "xhtml/06_Preface",
 			"component" : XHTML06_PREFACE
 		},
 		{
 			"path" : "/xhtml/07_Introduction",
 			"name" : "xhtml/07_Introduction",
 			"component" : XHTML07_INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js